var React = require('react');

function AdvisaBankIdAnimationOval (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"bankid-animation-oval-gradient"},[React.createElement("stop",{"offset":"0%","stopColor":"currentColor","key":0}),React.createElement("stop",{"offset":"50%","stopColor":"currentColor","stopOpacity":"0","key":1})])),React.createElement("title",{"key":1},"\n    Laddar\n  "),React.createElement("path",{"d":"M425,216c0,115.43-93.57,209-209,209S7,331.43,7,216,100.57,7,216,7","fill":"none","strokeMiterlimit":"10","strokeWidth":"11","stroke":"url(#bankid-animation-oval-gradient)","key":2})]);
}

AdvisaBankIdAnimationOval.defaultProps = {"viewBox":"0 0 432 432"};

module.exports = AdvisaBankIdAnimationOval;

AdvisaBankIdAnimationOval.default = AdvisaBankIdAnimationOval;
